module.exports = __webpack_public_path__ + "img/onboarding-inactive.aa3081e1.svg";